// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-loader.vld-overlay{position:relative}", "",{"version":3,"sources":["webpack://./resources/js/components/loaders/SectionLoader/SectionLoader.scss"],"names":[],"mappings":"AACE,4BACE,iBAAJ","sourcesContent":[".section-loader {\n  &.vld-overlay {\n    position: relative;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
